import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import scrollToComponent from 'react-scroll-to-component';

import * as locations from '../../../../constants/dropdown';
import {messageTextValidation, nameValidation, emailValidation, phoneValidation} from '../../../../utils/itemValidation';

import * as commonActionCreators from '../../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import RhinoSelect from '../../../common/inputs/RhinoSelect';

class SingleDesigner2022 extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

		const firstEntryNotReq = [{display: 'Location', 'value': ''}];
    const finalEntry = [{display: 'Other', 'value': 'online@diamondsdirect.com'}];
    let newArray= firstEntryNotReq.concat(locations.locations).concat(finalEntry);

		this.state = {
			locations: newArray,
			inputName: '',
			inputEmail: '',
			inputPhone: '',
			inputLocation: '',
			inputMessage: '',
			inputDesigner: '',
			
			errorName: null,
			errorEmail: null,
			errorPhone: null,
			errorLocation: null,
			errorMessage: null,
			errorDesigner: null,
			errorDesignerLocation: null,

			designerLocation: null,
		};

		this.designerData = {
			'atx': {
				url: 'austin', 
				designer: 'Tacori', 
				week: 4,
			},
			'bay': {
				url: 'baybrook', 
				designer: 'SimonG', 
				week: 2,
			},
			'bhm': {
				url: 'birmingham', 
				designer: 'Tacori', 
				week: 1,
			},
			'boc': {
				url: 'boca-raton', 
				designer: 'SimonG', 
				week: 3,
			},
			'chs': {
				url: 'charleston', 
				designer: 'Tacori', 
				week: 1,
			},
			'cle': {
				url: 'cleveland', 
				designer: 'Verragio', 
				week: 1,
			},
			'clt': {
				url: 'charlotte', 
				designer: 'Tacori', 
				week: 2,
			},
			'coh': {
				url: 'columbus', 
				designer: 'Tacori', 
				week: 2,
			},
			'dfw': {
				url: 'dallas', 
				designer: 'SimonG', 
				week: 3,
			},
			'ftx': {
				url: 'frisco', 
				designer: 'SimonG', 
				week: 3,
			},
			'gsc': {
				url: 'greenville', 
				designer: 'Tacori', 
				week: 4,
			},
			'hou': {
				url: 'houston', 
				designer: 'SimonG', 
				week: 2,
			},
			'ind': {
				url: 'indianapolis', 
				designer: 'Christopher', 
				week: 2,
			},
			'jax': {
				url: 'jacksonville', 
				designer: 'Christopher', 
				week: 4,
			},
			'kcy': {
				url: 'kansas-city', 
				designer: 'Divine', 
				week: 2,
			},
			'nol': {
				url: 'new-orleans', 
				designer: 'Verragio', 
				week: 3,
			},
			'nva': {
				url: 'tysons', 
				designer: 'MichaelM', 
				week: 3,
			},
			'okc': {
				url: 'oklahoma-city', 
				designer: 'Christopher', 
				week: 4,
			},
			'pit': {
				url: 'pittsburgh', 
				designer: 'Tacori', 
				week: 1,
			},
			'ral': {
				url: 'raleigh', 
				designer: 'Tacori', 
				week: 2,
			},
			'rva': {
				url: 'richmond', 
				designer: 'Uneek', 
				week: 3,
			},
			'stl': {
				url: 'st-louis', 
				designer: 'Verragio', 
				week: 1,
			},
			'san': {
				url: 'san-antonio', 
				designer: 'MichaelM', 
				week: 1,
			},
			'try': {
				url: 'troy', 
				designer: 'SimonG', 
				week: 3,
			},
			'vab': {
				url: 'virginia-beach', 
				designer: 'SimonG', 
				week: 2,
			},
		}

		this.designerLocationArray = [
			{
				display: 'Select Location',
				value: '',
			},
	    	{
				display: 'Austin, TX',
				value: 'atx',
			},
			{
				display: 'Birmingham, AL',
				value: 'bhm',
			},
			{
				display: 'Boca Raton, FL',
				value: 'boc',
			},
			{
				display: 'Charleston, SC',
				value: 'chs',
			},
			{
				display: 'Charlotte, NC',
				value: 'clt',
			},
			{
				display: 'Cleveland, OH',
				value: 'cle',
			},
			{
				display: 'Columbus, OH',
				value: 'coh',
			},
			{
				display: 'Dallas, TX',
				value: 'dfw',
			},
			{
				display: 'Frisco, TX',
				value: 'ftx',
			},
			{
				display: 'Greenville, SC',
				value: 'gsc',
			},
			{
				display: 'Houston, TX (Baybrook)',
				value: 'bay',
			},
			{
				display: 'Houston, TX (Galleria)',
				value: 'hou',
			},
			{
				display: 'Indianapolis, IN',
				value: 'ind',
			},
			{
				display: 'Jacksonville, FL',
				value: 'jax',
			},
			{
				display: 'Kansas City, KS',
				value: 'kcy',
			},
			{
				display: 'New Orleans, LA',
				value: 'nol',
			},
			{
				display: 'Oklahoma City, OK',
				value: 'okc',
			},
			{
				display: 'Pittsburgh, PA',
				value: 'pit',
			},
			{
				display: 'Raleigh, NC',
				value: 'ral',
			},
			{
				display: 'Richmond, VA',
				value: 'rva',
			},
			{
				display: 'St. Louis, MO',
				value: 'stl',
			},
			{
				display: 'San Antonio, TX',
				value: 'san',
			},
			{
				display: 'Troy, MI',
				value: 'try',
			},
			{
				display: 'Tysons, VA',
				value: 'nva',
			},
			{
				display: 'Virginia Beach, VA',
				value: 'vab',
			},
		];
	}

	internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  changeName(evt) {
		this.setState({ inputName: evt.target.value }, () => {
			if(this.state.errorName && !nameValidation(this.state.inputName)) {
				this.setState({ errorName: null });
			}
		});
	}

	changeEmail(evt) {
		this.setState({ inputEmail: evt.target.value }, () => {
			if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
				this.setState({ errorEmail: null });
			}
		});
	}

	changePhone(evt) {
		this.setState({ inputPhone: evt.target.value }, () => {
			if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
				this.setState({ errorPhone: null });
			}
		});
	}

	changeLocation(evt) {
		this.setState({ inputLocation: evt.target.value}, () => {
			if(this.state.errorLocation !== false && this.state.inputLocation !== '') {
				this.setState({errorLocation: null});
			}
		});
	}

	submitContactRequest() {
		if(this.validateAll()) {

			let contactData = {
				full_name: this.state.inputName,
				email: this.state.inputEmail,
				phone: this.state.inputPhone,
				location: this.state.inputLocation,
			}

			console.log(this.props);
			this.props.commonSummerContactRequest(contactData);
			// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
			this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
			this.setState({
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputDesigner: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
			});
		}
	}

	validateAll() {

    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let emailError = emailValidation(this.state.inputEmail);
    let locationError = nameValidation(this.state.inputLocation);

    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       locationError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorLocation: locationError,
    }, () => {
    	console.log(this.state);
    });

    return !hasErrors;
  }

  changeDesignerLocation(evt) {
  	this.setState({
  		designerLocation: evt.target.value,
  	}, () => {
  		this.scrollDown();
  	});
  }

  getFirstDay() {
  	if(!this.state.designerLocation || !this.designerData[this.state.designerLocation].week) {
  		return '';
  	}

  	switch(this.designerData[this.state.designerLocation].week) {
  		case 1:
  			return 'Friday, Sept 9';
  		case 2:
  			return 'Friday, Sept 16';
  		case 3:
  			return 'Friday, Sept 23';
  		case 4:
  			return 'Friday, Sept 30';
  	}
  	return '';
  }

  getSecondDay() {
  	if(!this.state.designerLocation || !this.designerData[this.state.designerLocation].week) {
  		return '';
  	}

  	switch(this.designerData[this.state.designerLocation].week) {
  		case 1:
  			return 'Saturday, Sept 10';
  		case 2:
  			return 'Saturday, Sept 17';
  		case 3:
  			return 'Saturday, Sept 24';
  		case 4:
  			return 'Saturday, Oct 1';
  	}
  	return '';
  }

  getDesignerImg() {
  	if(!this.state.designerLocation || !this.designerData[this.state.designerLocation].designer) {
  		return '';
  	}

  	switch(this.designerData[this.state.designerLocation].designer) {
  		case 'SimonG':
  			return 'simong.svg';
  		case 'Tacori':
  			return 'tacori.svg';
  		case 'Verragio':
  			return 'verragio.svg';
  		case 'Christopher':
  			return 'christopher.svg';
  		case 'Divine':
  			return 'divine.svg';
  		case 'MichaelM':
  			return 'michael.svg';
  		case 'Uneek':
  			return 'uneek.svg';
  	}
  	return '';
  }

  getDesignerLink() {
  	if(!this.state.designerLocation || !this.designerData[this.state.designerLocation].designer) {
  		return '';
  	}

  	if(this.designerData[this.state.designerLocation].week === 4) {
  		return `${this.designerData[this.state.designerLocation].url}?scroll=event`;
  	}

  	switch(this.designerData[this.state.designerLocation].designer) {
  		case 'SimonG':
  			return 'designer/simon-g-jewelry';
  		case 'Tacori':
  			return 'designer/tacori';
  		case 'Verragio':
  			return 'designer/verragio';
  		case 'Christopher':
  			return 'designer/christopher-designs';
  		case 'Divine':
  			return '';
  		case 'MichaelM':
  			return 'designer/michael-m';
  		case 'Uneek':
  			return 'designer/uneek';
  	}
  	return '';
  }

  scrollDown() {
    scrollToComponent(this.designerWrapper, {
      offset: -100, 
      align: 'top', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

	render() {
		return <div className='SingleDesigner2022'>
			<div className="promoBanner">
				<img className='desktop600' src="https://ddw2.diamondsdirect.com/img/promopages/singledesigner2022/header.jpg" alt="Diamonds Direct" />
				<img className='mobile600' src="https://ddw2.diamondsdirect.com/img/promopages/singledesigner2022/header_m.jpg" alt="Diamonds Direct" />
				<div className='headerSelectWrapper'>
					<RhinoSelect
						selectClass={'singleSelect'}
						value={this.state.designerLocation}
						options={this.designerLocationArray}
						changeMethod={(evt) => this.changeDesignerLocation(evt)} />
				</div>
			</div>
			<div className='designersWrapper' ref={(div) => { this.designerWrapper = div; }}>
				<div className='designerBlock'>

					{this.getDesignerLink() ?
						<div className='designerBanner' onClick={() => this.internalNav(this.getDesignerLink())} style={{ cursor: 'pointer' }}>
							{this.state.designerLocation ?
								<img src={'https://ddw2.diamondsdirect.com/img/promopages/singledesigner2022/' + this.getDesignerImg()} /> :
								null
							}
						</div> :
						<div className='designerBanner'>
							{this.state.designerLocation ?
								<img src={'https://ddw2.diamondsdirect.com/img/promopages/singledesigner2022/' + this.getDesignerImg()} /> :
								null
							}
						</div>
					}	

					{this.state.designerLocation ?
						<div className={'designerDisplay'}>
							<div className='daysWrapper'>
								<div className='dayBlock'>
									<div className='dayValue'>{this.getFirstDay()}</div>
									<div className='timeValue'>10 a.m. - 7 p.m.</div>
								</div>
								<div className='dayBlock'>
									<div className='dayValue'>{this.getSecondDay()}</div>
									<div className='timeValue'>10 a.m. - 6 p.m.</div>
								</div>
							</div>
						</div> :
						null
					}
				</div>
			</div>
			<div className='formBoxWrapper'>
				<div className='formInnerWrapper'>
					
					<div className='formP'>Walk-in visits are always welcome! But if you’d prefer to set up an appointment online or in store, please use the form below and we will follow up to confirm!</div>

					<div className='formWrapper'>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorName ? 'textInput error' : 'textInput'}
								type='text' 
								placeholder='Full Name*'
								value={this.state.inputName}
              					onChange={::this.changeName} />
						</div>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorEmail ? 'textInput error' : 'textInput'}
								type='email' 
								placeholder='Email Address*'
								value={this.state.inputEmail}
              					onChange={::this.changeEmail} />
						</div>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorPhone ? 'textInput error' : 'textInput'}
								type='text' 
								placeholder='Telephone'
								value={this.state.inputPhone}
              					onChange={::this.changePhone} />
						</div>
						<div className='formInputWrapper'>
							<RhinoSelect
				                selectClass={'summerSelect'}
				                required={true}
				                value={this.state.inputLocation}
				                options={this.state.locations}
				                changeMethod={(evt) => this.changeLocation(evt)}
				                error={this.state.errorLocation !== null} />
						</div>
						<div className='formActionRow'>
							<button className={'formAction'} onClick={::this.submitContactRequest}>Request an appointment</button>
						</div>
					</div>
				</div>
			</div>

			<div className='imagesSection'>
				<img className='desktop600' src="https://ddw2.diamondsdirect.com/img/promopages/singledesigner2022/editorial.jpg" alt="Diamonds Direct" />
				<img className='mobile600' src="https://ddw2.diamondsdirect.com/img/promopages/singledesigner2022/editorial_m.jpg" alt="Diamonds Direct" />
				<div className={'img1 imgLink'} onClick={() => this.internalNav('band/BDEMD00781')}></div>
				<div className={'img2 imgLink'} onClick={() => this.internalNav('setting/SMD1455187')}></div>
				<div className={'img3 imgLink'} onClick={() => this.internalNav('setting/SMD1818611')}></div>
			</div>

		</div>;
	}
}
export default SingleDesigner2022;

function mapStateToProps(state) {
  return {

  };
}

export const SingleDesigner2022Container = connect(
  mapStateToProps,
  allActionCreators
)(SingleDesigner2022);


// WEBPACK FOOTER //
// ./src/components/views/promopages/singledesigner2022/SingleDesigner2022.jsx